<div class="grid" [formGroup]="form">
  <div class="col-12 md:col-6 lg:col-3">
    <app-istat-regioni-input-select name="istatRegione" [form]="form"></app-istat-regioni-input-select>
  </div>
  <div class="col-12 md:col-6 lg:col-3">
    <app-istat-comuni-input-select name="istatComune" [form]="form" [filter]="'istatRegione_equals='+istatRegione()" [preload]="false"></app-istat-comuni-input-select>
  </div>
  <div class="col-12 md:col-8 lg:col-4">
    <app-punti-campionamento-tipologie-input-select name="tipoPuntoCampionamento" [form]="form"></app-punti-campionamento-tipologie-input-select>
  </div>
  <div class="col-12 md:col-4 lg:col-2">
    <app-input-text name="idPuntoCampionamento" label="Id. punto campionamento" icon="tag" [form]="form" placeholder="Inserisci l'identificativo" ></app-input-text>
  </div>
</div>
